import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import PaddedGrid from 'components/PaddedGrid';
import { useSelector } from 'react-redux';
import { makeSelectTextDirection } from 'containers/Main/selectors';

const useStyles = makeStyles(() => ({
  subtitle: {
    marginBottom: 20,
    marginTop: ({ type }) => (type === 'Episode' ? 20 : 0),
    direction: ({ textDirection }) => textDirection,
  },
  gridContainer: {
    position: 'relative',
  },
}));

function ResourceLinks({
  subtitle,
  section = 'popover',
  children,
  type = '',
  className,
}) {
  const textDirection = useSelector(makeSelectTextDirection());
  const classes = useStyles({ type, textDirection });
  const isInPopover = section === 'popover';
  return (
    <>
      <PaddedGrid className={className}>
        <Typography
          className={classes.subtitle}
          variant="subtitle2"
          color="textPrimary"
        >
          {subtitle}
        </Typography>
      </PaddedGrid>
      <PaddedGrid>
        <Grid
          className={classes.gridContainer}
          container
          spacing={2}
          direction={isInPopover ? 'column' : 'row'}
          alignItems={isInPopover ? 'center' : 'flex-start'}
        >
          {children}
        </Grid>
      </PaddedGrid>
    </>
  );
}

ResourceLinks.propTypes = {
  subtitle: PropTypes.string,
  section: PropTypes.string,
  children: PropTypes.node,
};

export default ResourceLinks;
